import {Component, Prop, Vue} from "vue-property-decorator";
import {Loading} from "element-ui";
import {setMessageReviewUserByMessageReviewId} from "@/api/message";

@Component({})
export default class RejectCommon extends Vue {
    @Prop() visible: false
    @Prop() data: {
        isFirstNode: false;
        isSyncEkuaibao: false;
        isSyncEqianbao: false;
        // approvalStatus: 0;
        approveId: number;
        status: number;
        isSync: boolean; // 驳回的时候退款、市场费用、返佣、合同 是否同步
    }
    @Prop() isContract: false
    @Prop() isCommison: false
    @Prop() isRefund: false
    @Prop() isMarketCost: false

    approvalOptions = [
        {label: '第一个', value: '0'},
        {label: '当前', value: '1'}
    ]

    isTouchEOptions = [
        {label: '否', value: '0'},
        {label: '是', value: '1'},
    ]

    disBtn = false
    isFirstNode = false
    isSyncEkuaibao = false
    isSyncEqianbao = false

    formData = {
        reviewIdea: '',
        rejectNode: '0',
        isTouchE: '0',
        isTouchEQ: '0',
    }

    //
    created() {

        this.isFirstNode = (this.data as any).isFirstNode
        this.isSyncEkuaibao = (this.data as any).isSyncEkuaibao
        this.isSyncEqianbao = (this.data as any).isSyncEqianbao
        if (this.isFirstNode === true) {
            this.formData.rejectNode = '0'
        }
        // if (this.isSyncEkuaibao === true) {
        //     this.formData.isTouchE = '1'
        // }
        if (this.isSyncEqianbao === true) {
            this.formData.isTouchEQ = '1'
        }
    }

    /*
    * methods*/
    closeReviewDialog() {
        this.formData.reviewIdea = ''
        this.formData.rejectNode = ''
        this.formData.isTouchE = ''
        this.formData.isTouchEQ = ''
        this.$emit('handleClose', false)
    }

    confirmReviewDialog() {
        // 关闭父级弹框
        this.disBtn = true
        this.$emit('doConfirm', false)
        const loading = Loading.service({
            text: `审批驳回中，请稍后`
        })
        let obj
        // 是退款
        if (this.data.isSync) {
            obj = {
                messageReviewId: this.data.approveId,
                status: this.data.status,
                opinion: this.formData.reviewIdea,
                form: {},
                nodeType: this.formData.rejectNode,
                isSync: this.isContract ? this.formData.isTouchEQ : this.formData.isTouchE,
            /*退款、返佣 、市场费用 -> isTouchE , 合同 -> isTouchEQ*/
            }
        } else {
            obj = {
                messageReviewId: this.data.approveId,
                status: this.data.status,
                opinion: this.formData.reviewIdea,
                form: {},
                nodeType: this.formData.rejectNode,
            }
        }

        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success('审批驳回')
            setTimeout(() => {
                loading.close()
                window.close()
            }, 1500)
        }).catch(() => {
            this.disBtn = false
            setTimeout(() => {
                loading.close()
            }, 500)
        })
    }
}
